import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { CellularResetSection } from './components/CellularResetSection';
import { WowMomentSection } from './components/WowMomentSection';
import { MirrorSection } from './components/MirrorSection';
import { VillainSection } from './components/VillainSection';
import { SymptomsSection } from './components/SymptomsSection';
import { MechanismSection } from './components/MechanismSection';
import { FascinationsSection } from './components/FascinationsSection';
import { TwoPathsSection } from './components/TwoPathsSection';
import { AuthorityStatementSection } from './components/AuthorityStatementSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { SafetyNetSection } from './components/SafetyNetSection';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-background font-sans text-navy selection:bg-accent selection:text-white" data-id="element-0">
      {/* noscript fallback for Meta Pixel */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=793935510144655&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <HeroSection data-id="element-3" />
      <CellularResetSection data-id="element-4" />
      <WowMomentSection data-id="element-5" />
      <MirrorSection data-id="element-6" />
      <VillainSection data-id="element-7" />
      <SymptomsSection data-id="element-8" />
      <MechanismSection data-id="element-9" />
      <FascinationsSection data-id="element-10" />
      <TwoPathsSection data-id="element-11" />
      <AuthorityStatementSection data-id="element-12" />
      <SocialProofSection data-id="element-13" />
      <FinalCtaSection data-id="element-14" />
      <SafetyNetSection data-id="element-15" />
    </main>;
}